var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2908 11.9997L14.8308 8.4597C15.017 8.27234 15.1216 8.01889 15.1216 7.7547C15.1216 7.49052 15.017 7.23707 14.8308 7.0497C14.7378 6.95598 14.6272 6.88158 14.5054 6.83081C14.3835 6.78004 14.2528 6.75391 14.1208 6.75391C13.9888 6.75391 13.8581 6.78004 13.7362 6.83081C13.6144 6.88158 13.5038 6.95598 13.4108 7.0497L9.1708 11.2897C9.07707 11.3827 9.00268 11.4933 8.95191 11.6151C8.90114 11.737 8.875 11.8677 8.875 11.9997C8.875 12.1317 8.90114 12.2624 8.95191 12.3843C9.00268 12.5061 9.07707 12.6167 9.1708 12.7097L13.4108 16.9997C13.5042 17.0924 13.6151 17.1657 13.7369 17.2155C13.8587 17.2652 13.9892 17.2905 14.1208 17.2897C14.2524 17.2905 14.3829 17.2652 14.5047 17.2155C14.6265 17.1657 14.7374 17.0924 14.8308 16.9997C15.017 16.8123 15.1216 16.5589 15.1216 16.2947C15.1216 16.0305 15.017 15.7771 14.8308 15.5897L11.2908 11.9997Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.28e012e28339dfa3ffe17ce338957407.svg";
export { ForwardRef as ReactComponent };